var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5602 7.41378L8.06018 13.9871C7.83351 14.3138 7.30018 14.1671 7.30018 13.7738L7.29351 10.0138C7.29351 9.58045 6.92685 9.23378 6.47351 9.22711L3.78684 9.19378C3.46017 9.18711 3.26685 8.84711 3.44685 8.58711L7.94685 2.01377C8.17351 1.68711 8.70685 1.83377 8.70685 2.22711L8.71351 5.98712C8.71351 6.42045 9.08018 6.76711 9.53351 6.77378L12.2202 6.80711C12.5402 6.80711 12.7335 7.15378 12.5602 7.41378Z",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.9421d900f4a73abb12d29c2cddb9145d.svg";
export { ForwardRef as ReactComponent };